import adAxios from '@ad/ad_utils/src/utils/mAxios';

const get = adAxios.get2;

export interface UserInfo {
  coreUserId: string | number;
}

export const fetchUserInfo = async () => {
  const { data }: any = await get('/marketing_api/api/login_context/get/');
  return data as UserInfo;
};

export function getUserLocation() {
  return get<{ countryCode: string; countryName: string }>(
    '/creative_hub_server/api/user/location',
    {},
    { showApiHint: false, overrideGlobalShowApiHint: true }
  );
}
